import { motion } from "framer-motion";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const countries = [
  { flag: "🇫🇷", name: "France" },
  { flag: "🇬🇧", name: "United Kingdom" },
  { flag: "🇩🇪", name: "Germany" },
  { flag: "🇮🇹", name: "Italy" },
  { flag: "🇪🇸", name: "Spain" },
  { flag: "🇺🇸", name: "United States" },
  { flag: "🇦🇪", name: "United Arab Emirates" },
  { flag: "🇸🇦", name: "Saudi Arabia" },
  { flag: "🇶🇦", name: "Qatar" },
  { flag: "🇰🇼", name: "Kuwait" },
  { flag: "🇳🇱", name: "Netherlands" },
  { flag: "🇧🇪", name: "Belgium" },
  { flag: "🇨🇭", name: "Switzerland" },
  { flag: "🇸🇪", name: "Sweden" },
  { flag: "🇳🇴", name: "Norway" },
  { flag: "🇩🇰", name: "Denmark" },
  { flag: "🇦🇹", name: "Austria" },
  { flag: "🇮🇪", name: "Ireland" },
  { flag: "🇨🇦", name: "Canada" },
  { flag: "🇦🇺", name: "Australia" },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.05 },
  },
};

const item = {
  hidden: { opacity: 0, scale: 0.5 },
  show: { opacity: 1, scale: 1 },
};

export function CountryFlags() {
  return (
    <TooltipProvider delayDuration={100}>
      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
        className="flex flex-wrap items-center justify-center gap-3 mt-8 max-w-xl mx-auto"
      >
        {countries.map((country) => (
          <Tooltip key={country.name}>
            <TooltipTrigger asChild>
              <span className="inline-flex">
                <motion.div
                  variants={item}
                  whileHover={{ scale: 1.2 }}
                  transition={{ type: "spring", stiffness: 400, damping: 18 }}
                  className="w-12 h-12 rounded-full bg-card border-2 border-amber-400/70 flex items-center justify-center text-2xl cursor-pointer shadow-[0_0_0_1px_hsl(var(--border))] hover:border-amber-400 hover:shadow-md hover:shadow-amber-200/30 transition-[border-color,box-shadow] duration-200"
                >
                  {country.flag}
                </motion.div>
              </span>
            </TooltipTrigger>
            <TooltipContent className="bg-foreground text-background text-sm font-medium">
              {country.name}
            </TooltipContent>
          </Tooltip>
        ))}
      </motion.div>
    </TooltipProvider>
  );
}
